/**
 * The onboarding answers handoff.
 *
 * ⚠️ The *authenticated* app reads these localStorage keys after signup to
 * personalize the welcome experience — the keys and the answer shape
 * (including the always-empty legacy fields) must stay byte-identical.
 */
const WELCOME_DIALOG_COMPLETED_KEY = 'cio-welcome-dialog-completed';
const WELCOME_DIALOG_ANSWERS_KEY = 'cio-welcome-dialog-answers';

// Drafts written by the old signup flow; cleared so a stale draft never leaks
// into a future flow change.
const LEGACY_SIGNUP_FLOW_DRAFT_KEY = 'cio-signup-flow-draft-v2';

export type WelcomeDialogAnswers = {
  messagingUseCases: string[];
  v2MessageChannels: string[];
  v2Role: string | null;
  selectedPlan: 'essentials' | 'builders' | null;
};

export function saveWelcomeDialogAnswers(answers: WelcomeDialogAnswers): void {
  try {
    localStorage.setItem(
      WELCOME_DIALOG_ANSWERS_KEY,
      JSON.stringify({
        messagingUseCases: answers.messagingUseCases,
        selectedChannels: [],
        emailVolumeSelection: null,
        v2MessageChannels: answers.v2MessageChannels,
        v2Role: answers.v2Role,
        selectedPlan: answers.selectedPlan,
        completedAt: new Date().toISOString(),
      }),
    );
    localStorage.setItem(WELCOME_DIALOG_COMPLETED_KEY, 'true');
    clearStoredSignupDraft();
  } catch {
    // Storage unavailable — the app falls back to asking in the welcome dialog.
  }
}

export function clearStoredSignupDraft(): void {
  try {
    localStorage.removeItem(LEGACY_SIGNUP_FLOW_DRAFT_KEY);
  } catch {
    // Storage unavailable — nothing persisted to clear.
  }
}
